import React from "react";
import { Switch } from "@/components/ui/switch";

const fr = (value) => Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 2 });
export const SuzukiConditionsPanel = ({ model, form, onChange }) => {
  const plan = model.suzuki_conditions;
  const company = form.company_type !== "NON";
  const rate = model.company_rates?.[form.company_type];
  const connected = form.is_suzuki_connected || !plan.connect_applicable;
  const participation = connected ? model.suzuki_connected_rate : model.suzuki_non_connected_rate;
  const cap = connected ? model.suzuki_connected_cap_ttc : model.suzuki_non_connected_cap_ttc;
  return (
    <section data-testid="suzuki-conditions-panel" className="mt-4 border-t pt-4 space-y-3">
      <h3 data-testid="suzuki-conditions-title" className="text-sm font-semibold">Suzuki · {plan.period}</h3>
      {company ? <p data-testid="suzuki-company-rule" className="text-sm">
        {rate === undefined ? "Catégorie non renseignée dans cette grille." : <>
          Marge VN {fr(model.base_margin_rate * 100)} % + participation Suzuki {fr(rate * 100)} % = <strong>{fr((model.base_margin_rate + rate) * 100)} % au total</strong>.
          <br />Remise client minimum : {fr(plan.minimum_company_discounts[form.company_type] * 100)} %. Pas de cumul avec les aides particuliers ou le Booster.
        </>}
      </p> : <>
        {plan.connect_applicable && <div className="flex items-center justify-between gap-3">
          <label htmlFor="suzuki-t4-connect" data-testid="suzuki-t4-connect-label" className="text-sm font-medium">Suzuki Connect activé</label>
          <Switch id="suzuki-t4-connect" data-testid="suzuki-t4-connect-switch" checked={form.is_suzuki_connected} onCheckedChange={(v) => onChange("is_suzuki_connected", v)} />
        </div>}
        <p data-testid="suzuki-participation-rule" className="text-sm text-muted-foreground">
          Participation Suzuki : {fr(participation * 100)} %, plafond {fr(cap)} € TTC ({fr(cap / 1.2)} € HT). Remise principale jusqu’à {fr(plan.main_discount_cap_ttc)} € TTC.
        </p>
        {plan.booster_eligible && <>
          <div className="flex items-center justify-between gap-3 border-t pt-3">
            <label htmlFor="suzuki-t4-booster" data-testid="suzuki-t4-booster-label" className="text-sm font-medium">Booster éligible · reprise ou Suzuki Finance</label>
            <Switch id="suzuki-t4-booster" data-testid="suzuki-t4-booster-switch" checked={form.has_boost_jpo} onCheckedChange={(v) => onChange("has_boost_jpo", v)} />
          </div>
          <p data-testid="suzuki-booster-rule" className="text-xs text-muted-foreground">Automatique sur le complément de remise, jusqu’à 1 000 € TTC : participation Suzuki de 80 %, plafonnée à 800 € TTC. Une seule remise globale, sans cumul sur le même montant.</p>
        </>}
        {(form.is_vd_sale || form.is_vdr_sale) && <p data-testid="suzuki-vd-rule" className="text-xs text-muted-foreground">Participation et Booster éligible cumulables avec {form.is_vd_sale ? "l’aide VD existante, sans marge de base" : "les conditions VK existantes"}.</p>}
      </>}
    </section>
  );
};